enum TerritoryAddOnServiceVariation {
  OFF = "off",
  MANUAL = "manual",
  FULL = "full",
}

export default TerritoryAddOnServiceVariation;
